export default "__VITE_ASSET__CYRsxF3o__"